

































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'

settings =
  name: 'WelcomeModal'

  vue:
    components: { Modal }

    data: ->
      visible: false

    methods:
      show: -> @visible = true
      close: -> @visible = false

      hiNavigateToMatches: ->
        @close()
        @$router.replace({ name: 'CampaignEventFeedStage' })

      hiNavigateToCheckout: ->
        @close()
        @$router.replace({ name: 'CampaignCheckoutStage' })

export default VueOptions.vue settings
